import React , {useEffect, useState} from "react";
import { Page, Text, View, Document, StyleSheet, Image, Font, Link } from '@react-pdf/renderer';
import ReactDOM from 'react-dom';
import { PDFViewer, PDFDownloadLink } from '@react-pdf/renderer';
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import FiberManualRecord from "@material-ui/icons/FiberManualRecord";


// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import ImageUpload from "components/CustomUpload/ImageUpload.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";

import logo from "assets/img/logo.png";
import default_geocode from "assets/img/default_geocode.png";


import {  Redirect, useParams } from "react-router-dom";

import axios from 'axios'

import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";

import Font_ from "assets/Urbanist-Light.ttf";
import { PUBLIC_FIGURES, PUBLIC_SIGNS, PUBLIC_STATUS } from "../../constants";

const useStyles = makeStyles(styles);

export default function NewUser() {

    const {id} = useParams();


    const [report, setreport] = React.useState([]);
    const [token_logged, settoken_logged] = React.useState("");
    const [redirctTo, setRedirctTo] = useState(false);
    const [redirctTo_new_user, setRedirctTo_new_user] = useState(false);
    const [tc, setTC] = React.useState(false);

    const [redirctTo_all, setRedirctTo_all] = useState(false);
    const [Errmessage, setErrmessage] = React.useState("");

    const [image_cover, setimage_cover] = React.useState("");
    const [image_cover_b64, setimage_cover_b64] = React.useState("");

    const [sections, setsections] = React.useState([]);

    //const image_url = "http://localhost:5000/public/";
    const image_url_s = PUBLIC_SIGNS;
    const image_url_f = PUBLIC_FIGURES;

    // Firebase production bucket URL
    const FIREBASE_PRODUCTION_BUCKET = "https://firebasestorage.googleapis.com/v0/b/arcorapp.appspot.com/o/images%2F";

    // Helper function to construct Firebase URL using production bucket and dynamic token
    const getFirebaseImageUrl = (imageName) => {
      const token = process.env.REACT_APP_FIREBASE_TOKEN || "6bf3ba62-0825-4527-a9e6-2215c0ca1901";
      return `${FIREBASE_PRODUCTION_BUCKET}${imageName}?alt=media&token=${token}`;
    };

    // Firebase Image Component for production bucket
    const SmartFirebaseImage = ({ imageName, photoCount, style }) => {
      const imageUrl = getFirebaseImageUrl(imageName);

      const handleImageLoad = () => {
        console.log("Image loaded successfully from production bucket:", imageUrl);
      };

      const handleImageError = () => {
        console.log("Image failed to load from production bucket:", imageName);
      };

      return (
        <a target="blank" href={imageUrl}>
          <img
            style={style}
            src={imageUrl}
            alt="Report Image"
            onLoad={handleImageLoad}
            onError={handleImageError}
          />
          <div style={{ position: "relative", marginTop: "-30px", fontSize: "17px", fontWeight: "bold", color: "black", textAlign: "right", padding: "0px 5px" }}>
            <span style={{ backgroundColor: "white", color: "black", padding: "0px 5px" }}>{photoCount}</span>
          </div>
        </a>
      );
    };

    
    
   

  
  React.useEffect(() => {
      
      document.getElementById("test_id").innerHTML = "Images";

      // Debug Firebase environment variables
      console.log("=== Firebase Environment Variables Debug ===");
      console.log("REACT_APP_FIREBASE_BUCKET_URL:", process.env.REACT_APP_FIREBASE_BUCKET_URL);
      console.log("REACT_APP_FIREBASE_TOKEN:", process.env.REACT_APP_FIREBASE_TOKEN);
      console.log("REACT_APP_FIREBASE_APIKEY:", process.env.REACT_APP_FIREBASE_APIKEY);
      console.log("All REACT_APP env vars:", Object.keys(process.env).filter(key => key.startsWith('REACT_APP')));
      console.log("=== End Debug ===");

      const local_login = localStorage.getItem('local_login')
      let token = "";
      if(local_login){
        try {
        const getToken = async () => {
          const res = await axios.post('/user/refresh_token', null)
          
          token = res.data.access_token;

          settoken_logged(token);

          const res2 = await axios.get('/user/infor', {
            headers: {Authorization: token}
          })     
          console.log( res2.data );

          const res3 = await axios.post('/codeset/info_report', {id},{
            headers: {Authorization: token}
          })
          let codes_show = []
          let report_ = {};
          console.log(res3.data.report_type);
          if(res3.data.report_type == 2){
            report_ = JSON.parse(res3.data.long_report1 + res3.data.long_report2 )  
          }else{
            report_ = JSON.parse(res3.data.report )  
          }

          let all_images =  [];

          for (let i = 0; i < report_.sections.length; i++) {
            for (let l = 0; l < report_.sections[i].photos_gallery.length; l++) {
              all_images.push(report_.sections[i].photos_gallery[l]);
            }  
          }

          console.log( all_images );

          console.log( report_ );

          // Debug image URLs construction
          console.log("=== Image URL Construction Debug ===");
          for (let i = 0; i < all_images.length; i++) {
            console.log(`Image ${i}:`, {
              uuid: all_images[i].uuid,
              upload_name: all_images[i].upload_name,
              constructed_url: getFirebaseImageUrl(all_images[i].upload_name)
            });
          }
          console.log("=== End Image URL Debug ===");
          setreport(report_)
          let images_count = 1;
          for (let i = 0; i < report_.sections.length; i++) {
            for (let j = 0; j < report_.sections[i].sections.length; j++) {
              for (let k = 0; k < report_.sections[i].sections[j].code_references.length; k++) {
                report_.sections[i].sections[j].code_references[k].section_name_show = report_.sections[i].sections[j].section_name;
                codes_show.push(report_.sections[i].sections[j].code_references[k]);
                report_.sections[i].sections[j].code_references[k].photos_added_show = [];
                for (let l = 0; l < all_images.length; l++) {
                  if(report_.sections[i].sections[j].code_references[k].photos_added.includes(all_images[l].uuid)){                    
                    let item = {}
                    item.name = all_images[l].upload_name;
                    item.count = images_count;
                    report_.sections[i].sections[j].code_references[k].photos_added_show.push(item)
                    images_count++
                  }
                }  
                report_.sections[i].sections[j].code_references[k].figures_added_show = [];  
                
                for (let s = 0; s < report_.sections[i].sections[j].code_references[k].figures_added.length; s++) {
                  if(report_.sections[i].sections[j].code_references[k].figures_added[s].status){
                    report_.sections[i].sections[j].code_references[k].figures_added_show.push(report_.sections[i].sections[j].code_references[k].figures_added[s])
                  }
                }     
                
                                
                
              }
            }
          }

          if(report_.cover_type == 'google'){
            setimage_cover( getFirebaseImageUrl(report_.cover_url_upload))
          }
          if(report_.cover_type == 'camera'){
            setimage_cover( getFirebaseImageUrl(report_.cover_url_upload))
          }


          console.log(codes_show);

          setsections(codes_show)

          
        }
        getToken()
          } catch (err) {
            setRedirctTo(true);
        }
      }else{
        setRedirctTo(true)
      }

          
  }, [  ]);
  


  const classes = useStyles();

  if (redirctTo){
    return <Redirect to='/auth/login-page'  />
  }

  if (redirctTo_new_user){
    return <Redirect to={'/admin/reports/'}  />
  }

  Font.register({
    family: 'Urbanist',
    src: Font_
  });


   // Create styles
  const styles = StyleSheet.create({
    page: {
      flexDirection: 'column',
      backgroundColor: '#FFFFFF',
      paddingTop: 20,
      paddingBottom: 20,
      paddingHorizontal: 20,
      fontFamily: 'Urbanist',
    },
    section: {
      fontSize: "9px",
      fontWeight: "light",
      width: "25%",
    },
    section_title: {
      textAlign: "center",
      fontWeight: "bold",
      fontSize: "9px",
    },
    title_text: {
      fontSize: "9px", 
      textAlign: "center",
      alignSelf: "center"
    },
    section_logo: {
      textAlign: "right",   
      alignContent: "flex-end",
      width: "25%",
    },
    p_text: {
      fontSize: "9px", 
      textAlign: "justify",
      paddingTop: 10
    },
    code_header: {
      flexDirection: 'row',
      backgroundColor: "#224B8B",
      color: "white",
      padding: "10px 10px",
      fontSize: "16px"
    },
    code_header2: {
      flexDirection: 'row',
      backgroundColor: "#000",
      color: "white",
      padding: "10px 10px",
      fontSize: "16px"
    },
  });

  // Create Document Component
  const MyDocument = () => (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={{flexDirection: "row"}} >
        <View style={styles.section}>
          <Text style={{width: "140%"}} >Prepared By: Arcor Inc </Text>
          <Text style={{width: "140%"}}>Created: Febuary 1 2021 </Text>
          <Text style={{width: "140%"}}>Report Number: 011620-221a </Text>
        </View>
        <View style={styles.section_title }>
          <Text style={styles.title_text}>PARTIAL DISABLED ACCESS COMPLIANCE AUDIT REPORT</Text>
          <Text style={styles.title_text}>PROTECTED BY ATTORNEY/CLIENT WORK PRODUCT PRIVILEGE</Text>
        </View>
        {(logo != "") && (
          <View style={styles.section_logo }>
            <Image
              style={{height: "50px", width: "50px", alignSelf: "flex-end"}}
              src={logo}
            />
          </View>
        )}
        </View>
        <View style={{flexDirection: "column", paddingBottom: 10}} >
          <Text style={styles.title_text}>REPORT NAME</Text>
          <Text style={styles.title_text}>{report.report_name}</Text>
        </View>
        {(image_cover != "") && (
        <View style={{flexDirection: "column", justifyContent: "center", margin_top: "15px"}} >
         <Image
            style={{ width: "90%", alignSelf: "center", margin_top: "15px" }}
            src={image_cover}
          />
        </View>
        )}
        <View style={{flexDirection: "column", paddingBottom: 10}} >
          <Text style={styles.p_text}>This in accordance with the requirements for issuance of the CASp certificate, this certificate will likely be issued as "CASp Determination Pending". A CASp determination pending means there are barriers to access, which are noted in the CASp inspection report. Once all barriers are corrected to the fullest extent possible, then the certification will be changed to "CASp-Inspected" as per a letter referencing such.</Text>
          <Text style={styles.p_text}>It does not matter whether your certification is designated as "CASp determination pending" or "CASp-Inspected" the “special legal rights and responsibilities” granted in accordance with SB 262 and SB 1608 have been invoked.</Text>
          <Text style={styles.p_text} >If accessibility related lawsuit is filed against your property or businesswith a CASp certificate, you can apply for 90 day stay of the lawsuit and a mandatory early evaluation conference (ECC) within 35 days, as they are what is called a "qualified defendant". The defendant is required to produce the CASp report for the plaintiff review 15 days prior to ECC. The plaintiff must provide basis of claimed violations and costs 15 days prior to ECC. As a qualified business you must display a CASp issued numbered, watermarked Disability Access Certificate once you receive it. It is this that can help reduce potential legal costs which usually occur as a result of the extensive time spent when the plaintiff tries to get a "settlement" award. It also means that you can request an early evaluation conference with a judge or commissioner who has received specialized training in accessibility laws and requirements who will review the case and any claimed violations. It is the "special legal rights" that one receives that reduces the likelihood of a "certified" business being targeted with frivolous law suits. Of course this is also a law that aims to ensure that the rights of those with disabilities will be respected and catered for.</Text>
        </View>
        
        <View break></View>
       
          {sections.map((code_reference,key_section1) =>
            
                  <View style={{marginTop: "15px"}} >
                    <View style={styles.code_header}  >  
                        <View style={{text_aling: "center", width: "50%", flexDirection: "row"}}>
                          <Text style={{fontSize: "11px", fontWeight: 600}} >Section </Text><Text style={{fontSize: "10px"}} >{code_reference.section_name_show} </Text>
                        </View>
                        <View style={{text_aling: "center", width: "50%", flexDirection: "row"}} >
                        <Text style={{fontSize: "11px", fontWeight: "bold"}} >Code Reference  </Text><Text style={{fontSize: "10px"}}>{ String( code_reference.reference)} </Text>
                        </View>                
                    </View>

                    <View style={{flexDirection: "row", paddingTop: "10px"}}>
                          <Text style={{width: "30%",fontSize: "10px", padding: "5px"}}>Code Description</Text>
                          <Text style={{width: "10%",fontSize: "10px", padding: "5px"}}>Status</Text>
                          <Text style={{width: "30%",fontSize: "10px", padding: "5px"}}>Comments</Text>
                          <Text style={{width: "30%",fontSize: "10px", padding: "5px"}}>Recommendations</Text>
                    </View>

                    <View style={{flexDirection: "row", paddingTop: "10px"}}>
                          <Text style={{width: "30%",fontSize: "8px", padding: "5px" }}>{code_reference.description}</Text>
                          <View style={{width: "10%",fontSize: "8px", padding: "5px", alignContent: "center", alignItems: "center" }}>
                            <Image
                              style={{width: "90%"}}
                              src={`${PUBLIC_STATUS}/status${code_reference.status}.png`}
                            />
                          </View>
                          {(code_reference.comments_added.length > 0) && ( 
                            <View style={{width: "30%",fontSize: "8px", padding: "5px", flexDirection: "column" }}>
                              {code_reference.comments_added.map((comment,comment_key) =>
                                <View style={{flexDirection: "column"}}>
                                  <Text>
                                  {comment.comment_text}
                                  </Text>
                                </View>
                              )}
                            </View>
                          )}
                          {(code_reference.comments_added.length == 0) && ( 
                            <Text style={{width: "30%",fontSize: "8px", padding: "5px", flexDirection: "row" }}>                              
                                <Text>
                                   N/A
                                </Text>
                            </Text>
                          )}
                          {(code_reference.recommendations_added.length > 0) && ( 
                            <View style={{width: "30%",fontSize: "8px", padding: "5px", flexDirection: "column"}}>
                              {code_reference.recommendations_added.map((recommendation,recommendation_key) =>
                                <View>
                                  <Text>
                                  {recommendation.recommendation_text}
                                  </Text>
                                </View>
                              )}
                            </View>
                          )}
                          {(code_reference.recommendations_added.length == 0) && ( 
                            <Text style={{width: "30%",fontSize: "8px", padding: "5px", flexDirection: "row" }}>                              
                                <Text>
                                   N/A
                                </Text>
                            </Text>
                          )}
                    </View>
                    {(code_reference.photos_added_show.length > 0) && ( 
                      <View> 
                        <View style={{flexDirection: "column", paddingBottom: 10, marginTop: 20}} >
                          <Text style={{ fontSize: "12px", textAlign: "center",alignSelf: "center"}}>Site Photos</Text>
                        </View>

                        <View style={{flexDirection:'row', flexWrap: "wrap", marginTop: 10}} >
                          {code_reference.photos_added_show.map((photo,photo_key) =>
                            <View style={{width: "33.33%", paddingHorizontal: "10px"}}>
                              <Link to={getFirebaseImageUrl(photo.name)} >
                              <Image
                                style={{width: "100%"}}
                                src={getFirebaseImageUrl(photo.name)}
                              />
                              </Link>
                            </View>
                          )}
                        </View>
                    </View>
                    )}

                    {(code_reference.figures_added_show.length > 0) && ( 
                      <View> 
                        <View style={{flexDirection: "column", paddingBottom: 10, marginTop: 20}} >
                          <Text style={{ fontSize: "12px", textAlign: "center",alignSelf: "center"}}>Figure Examples</Text>
                        </View>

                        <View style={{flexDirection:'row', flexWrap: "wrap", marginTop: 10}} >
                          {code_reference.figures_added_show.map((figure,photo_key) =>
                            <View style={{width: "50%", paddingHorizontal: "10px"}}>
                              <Link  >
                                
                                <Image
                                  style={{width: "100%"}}
                                  src={image_url_f + report.dataset_description.split(" ").join("_").split("(").join("").split(")").join("") +  "/" +  figure.img + ".png"}
                                />
                              
                              </Link>
                            </View>
                          )}
                        </View>
                    </View>
                    )}                    
                    {(code_reference.signs_added.length > 0) && ( 
                      <View> 
                        <View style={{flexDirection: "column", paddingBottom: 10, marginTop: 20}} >
                          <Text style={{ fontSize: "12px", textAlign: "center",alignSelf: "center"}}>Anticipated Cost Of Repair</Text>
                        </View>
                        {report.signs.map((sign,sign_key) =>
                            <View style={{flexDirection: "column", width: "100%" }} > 
                              {(code_reference.signs_added[sign_key] > 0) && (
                                <View style={{flexDirection: "row", marginBottom: "15px" }} > 
                                    <View style={{width: "10%"}}>                                
                                      <Image
                                        style={{width: "100%"}}
                                        src={image_url_s + sign.image}
                                      />
                                    </View>
                                    <View style={{width: "50%", flexDirection: "column", fontSize: "10px", paddingLeft: "15px"}}> 
                                        <Text style={{marginBottom: "10px"}} >Sign: {sign.name}</Text>
                                        <Text style={{marginBottom: "10px"}} >Quantity: {code_reference.signs_added[sign_key]}</Text>
                                        <Text style={{marginBottom: "10px"}} >Total Anticipated Cost Of Repair: ${((parseFloat(sign.sign_cost) + parseFloat(sign.sign_labor) ) * parseFloat(code_reference.signs_added[sign_key])).toFixed(2) }</Text>
                                    </View>  
                                </View>
                              )}
                            </View>
                            
                        )}
                      </View>
                    )}

                    {(code_reference.method == 2) && (
                      <View> 
                        <View style={{flexDirection: "column", paddingBottom: 10, marginTop: 20}} >
                          <Text style={{ fontSize: "12px", textAlign: "center",alignSelf: "center"}}>Anticipated Cost Of Repair</Text>
                        </View>
                        <View style={{flexDirection: "column", fontSize: "10px", paddingLeft: "15px"}}> 
                            <Text style={{marginBottom: "10px"}} >Measurements: {code_reference.l_ft * code_reference.w_ft }SQFT ({ code_reference.l_ft }FT Wide x { code_reference.w_ft }FT Long)</Text>
                            <Text style={{marginBottom: "10px"}} >Total Anticipated Cost Of Repair: ${((parseFloat(code_reference.l_ft) * parseFloat(code_reference.w_ft) ) * ( parseFloat(code_reference.labor_cost) * parseFloat(code_reference.material_cost)  ) ) .toFixed(2) }</Text>
                        </View> 

                      </View>
                    )}

                  </View>


          )}

          <View break>

            <View style={styles.code_header2}  >  
                <View style={{text_aling: "center", width: "100%", flexDirection: "row"}}>
                  <Text style={{fontSize: "11px", fontWeight: 600}} >Anticipated Cost Summary </Text>
                </View>               
            </View>

            {sections.map((code_reference,key_section1) =>
              
                        <View>                            
                            
                            {(code_reference.signs_added.length > 0) && ( 
                              <View style={{fontSize: "11px"}} > 
                                <View style={{flexDirection: "row", paddingTop: "10px", fontSize: "11px"}}>
                                    <Text style={{width: "35%",fontSize: "11px", padding: "5px"}}>Code Reference</Text>
                                    <Text style={{width: "30%",fontSize: "11px", padding: "5px"}}>Sign</Text>
                                    <Text style={{width: "20%",fontSize: "11px", padding: "5px"}}>Quantity</Text>
                                    <Text style={{width: "15%",fontSize: "11px", padding: "5px"}}>Total</Text>
                                </View>
                                {report.signs.map((sign,sign_key) =>
                                  <View style={{flexDirection: "column", width: "100%"}}>
                                    {(code_reference.signs_added[sign_key] > 0) && ( 
                                      <View style={{flexDirection: "row", paddingTop: "10px"}}>
                                            <Text style={{width: "35%",fontSize: "9px", padding: "5px"}}>{code_reference.reference}</Text>
                                            <Text style={{width: "30%",fontSize: "9px", padding: "5px"}}>{ sign.name }</Text>
                                            <Text style={{width: "20%",fontSize: "9px", padding: "5px"}}>{code_reference.signs_added[sign_key]}</Text>
                                            <Text style={{width: "15%",fontSize: "9px", padding: "5px"}}>${((parseFloat(sign.sign_cost) + parseFloat(sign.sign_labor) ) * parseFloat(code_reference.signs_added[sign_key])).toFixed(2) }</Text>
                                      </View>
                                    )}
                                  </View>
                                )}
                              </View>
                            )}

                            {(code_reference.method == 2) && ( 
                              <View style={{fontSize: "11px"}} > 
                                <View style={{flexDirection: "row", paddingTop: "10px", fontSize: "11px"}}>
                                    <Text style={{width: "35%",fontSize: "11px", padding: "5px"}}>Code Reference</Text>
                                    <Text style={{width: "30%",fontSize: "11px", padding: "5px"}}>Sign</Text>
                                    <Text style={{width: "20%",fontSize: "11px", padding: "5px"}}>Measurement</Text>
                                    <Text style={{width: "15%",fontSize: "11px", padding: "5px"}}>Total</Text>
                                </View>
                                <View style={{flexDirection: "row", paddingTop: "10px"}}>
                                      <Text style={{width: "35%",fontSize: "9px", padding: "5px"}}>{code_reference.reference}</Text>
                                      <Text style={{width: "30%",fontSize: "9px", padding: "5px"}}>Not Applicable</Text>
                                      <Text style={{width: "20%",fontSize: "9px", padding: "5px"}}>{code_reference.l_ft * code_reference.w_ft }SQFT</Text>
                                      <Text style={{width: "15%",fontSize: "9px", padding: "5px"}}>${((parseFloat(code_reference.l_ft) * parseFloat(code_reference.w_ft) ) * ( parseFloat(code_reference.labor_cost) * parseFloat(code_reference.material_cost)  ) ) .toFixed(2) }</Text>
                                </View>
                              </View>
                            )} 

                        </View>
                      
            )}     

            </View>
          </Page>

     

    </Document>
  );

  if(sections.length > 0){ 
    //ReactDOM.render(<App />, document.getElementById('root'));
  } 

  if (redirctTo_all){
    return <Redirect to={'/admin/report/' + id + "/1"}    />
  }

  const showNotification = place => {
    setTC(true);
    setTimeout(function() {
      setTC(false);
    }, 3000);
  };
  
  
  return (
    <div>

      <Snackbar
        place="tc"
        color="rose"
        icon={AddAlert}
        message={Errmessage}
        open={tc}
        closeNotification={() => setTC(false)}
        close
      />
      
      <GridContainer>
          
        <GridItem xs={12} sm={12} md={12}>
            <div className={classes.right}>
              
                  <Button onClick={(e)=>setRedirctTo_all(true)}  color="rose" className={classes.right}>
                      Back to Report
                  </Button>
             
                
            </div>
            
          <Card style={{padding: "20px"}} >
            
                {(sections.length > 0) && ( 
                  <div> 
                  {sections.map((code_reference,key_section1) =>
                    <div> 
                    {(code_reference.photos_added_show.length > 0) && ( 
                      <div >
                        {code_reference.photos_added_show.map((photo,photo_key) => {
                          const imageUrl = getFirebaseImageUrl(photo.name);
                          console.log("=== Rendering Image Debug ===");
                          console.log("Photo object:", photo);
                          console.log("Environment check:", {
                            bucket_url_exists: !!process.env.REACT_APP_FIREBASE_BUCKET_URL,
                            token_exists: !!process.env.REACT_APP_FIREBASE_TOKEN,
                            bucket_url: process.env.REACT_APP_FIREBASE_BUCKET_URL,
                            token: process.env.REACT_APP_FIREBASE_TOKEN
                          });
                          console.log("Final image URL:", imageUrl);
                          console.log("=== End Rendering Debug ===");
                          
                          return (
                            <div key={photo_key} style={{marginBottom: "10px", width: "310px", float: "left", height: "340px", padding: "20px", justifyContent: "center" }}>
                                <SmartFirebaseImage 
                                  imageName={photo.name}
                                  photoCount={photo.count}
                                  style={{ width: "100%", height: "300px" }}
                                />
                            </div>
                          );
                        })}
                      </div> 
                    )} 
                    </div> 
                  )} 
                  </div> 
                )}
            
          </Card>

          
          <div className={classes.right}>
              {(sections.length > 0) && ( 
                  <Button onClick={(e)=>setRedirctTo_all(true)}   color="rose" className={classes.right}>
                      Back to Report
                  </Button>
              )}
                
            </div>
        </GridItem>
      </GridContainer>
    </div>
    
  );
}
